/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        var els = document.querySelectorAll('.box_mostread .tabs a');
        if (!els || els.length <= 1) {
            return;
        }
        els.forEach(function (el) {
            el.addEventListener('click', function () {
                els.forEach(function (button) {
                    button.classList.toggle('selected');
                });
                document.querySelectorAll('.box_mostread .items').forEach(function (item) {
                    item.classList.toggle('hide');
                });
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
